import * as React from "react";
import ReactFlexyTable from "react-flexy-table";
import "react-flexy-table/dist/index.css";
import { callApi } from "../../utils/api";
import { ToastsContainer, ToastsContainerPosition, ToastsStore } from "react-toasts";
import moment from "moment";
import { toast } from "react-toastify";
import { ADMIN_ROLE } from "../../utils/role";
import { hasPageAccess } from "../../utils/pagePermissionService";

interface AllProps {
    history: any;
}
declare var $: any;
class SignatureInprogressFile extends React.Component<AllProps> {
    state = {
        selectVal: false,
        outreason: "",
        filesCount: '',
        fileToBeAssigned: 0,
        isFileRefresh: false,
        totalCount: 0,
        takeFiles: [],
        autoAssign: [
            {
                "id": "1",
                "module_name": "Auto Assign",
                "status": false
            }
        ],
        takenfiles: [],
        queuefiles: "",
        takeTime: false,
        isLoading: false
    };
    async componentDidMount() {
        this.gettakenFiles();
        this.getOutTime();
        const hasHide = await hasPageAccess("In-Reason/Out-Reason Hide");
        if (!hasHide) {
            this.ouTime();
        }
        // this.getAutoAssignStatus();
        this.getDeviationQueueFiles();
    }
    getDeviationQueueFiles = () => {
        const user: any = localStorage.getItem("user");
        const userId = user ? JSON.parse(user)["userId"] : "";
        let req = {
            userId: userId
        }
        callApi("POST", "get_sign_pending_files.php", req)
            .then((res) => res.data)
            .then((response) => {
                this.setState({ filesCount: response?.responseJson?.totalRecords });
            })
            .catch((err) => {
                console.log(err);
            });
    };
    getAutoAssignStatus = () => {
        callApi("GET", "module_option_select.php", "")
            .then((res) => res.data)
            .then((result) => {
                this.setState({ autoAssign: result.responseJson.data });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    previousPop = () => {
        $("#out_reason").modal("show");
        $("#another-reason").modal("hide");
    }
    BacktoFile = () => {
        $("#out_reason").modal("hide");
        const fileid1: any = localStorage.getItem("currentfileId");
        this.props.history.push("/file-dashboard/" + JSON.parse(fileid1));
    }
    getOutTime = () => {
        let date = new Date();
        let stratTime = date.getTime();
        localStorage.setItem("startTime", JSON.stringify(stratTime))
        let outDate = date.toLocaleDateString();
        localStorage.setItem("OutDateGet", JSON.stringify(outDate));
        var Railway = date.getMinutes();
        if (Railway < 10) {
            var TotalMinutes = "0" + Railway;
            let ouTtime = date.getHours() + ":" + TotalMinutes;
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        }
        else {
            let ouTtime: any = date.getHours() + ":" + date.getMinutes();
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        }

    }
    ouTime = () => {
        const getfileId: any = localStorage.getItem("currentfileId");
        console.log("54", JSON.parse(getfileId))
        console.log("32", getfileId);
        if (localStorage.getItem("currentfileId")) {
            $("#out_reason").modal("show");
        }
    }
    outimeGet = () => {
        this.setState({ isLoading: true });
        const fileid1: any = localStorage.getItem("currentfileId");
        const userid1: any = localStorage.getItem("user1");
        const inreason: any = localStorage.getItem("in_reason");
        const intime: any = localStorage.getItem("IntimeGet");
        const outtime: any = localStorage.getItem("outtimeGet");
        const outdate: any = localStorage.getItem("OutDateGet");
        const secondsSpent = moment(outtime, "HH:mm").diff(moment(intime, "HH:mm"), 'seconds');
        let updatedRemainingTime: any = localStorage.getItem('updatedRemainingTime');
        let updatedtime = Math.round(updatedRemainingTime);
        const status: any = localStorage.getItem("dashboard_status");
        const insertId: any = localStorage.getItem("ProcessEodInsertID");
        if (this.state.outreason == "") {
            this.setState({ selectVal: true });
        }
        else {
            let obj = {
                "file_id": JSON.parse(fileid1),
                "user_id": JSON.parse(userid1),
                "in_reason": JSON.parse(inreason),
                "out_reason": this.state.outreason,
                "intime": JSON.parse(intime),
                "outtime": JSON.parse(outtime),
                "insert_date": JSON.parse(outdate),
                "total_seconds": secondsSpent,
                "balance_min": updatedtime,
                "dashboard_status": status,
                "insert_id": insertId
            }
            callApi("POST", "process_eod_insert.php", obj)
                .then(res => res.data)
                .then(response => {
                    this.setState({ isLoading: false });
                    localStorage.removeItem('updatedRemainingTime');
                    localStorage.removeItem("in_reason");
                    localStorage.removeItem("outreason");
                    localStorage.removeItem("IntimeGet");
                    localStorage.removeItem("OutDateGet");
                    localStorage.removeItem('takenfile_id');
                    $("#out_reason").modal("hide");
                    $("#another-reason").modal("hide");
                    ToastsStore.success("Your Reason Saved Successfully");
                    let file_id = JSON.parse(fileid1);
                }).catch((err) => {
                    console.log(err);
                    this.setState({ isLoading: false });
                    ToastsStore.error("Your Reason Not Stored");
                })
        }
    }
    onchangeReason = (e: any) => {
        if (e.target.value == "Other") {
            this.setState({ in_reason: "", selectVal: false })
            $("#out_reason").modal("hide");
            $("#another-reason").modal("show");
        }
        else if (e.target.value == "select") {
            this.setState({ setResponse: false })
        }
        else {
            this.setState({ [e.target.name]: e.target.value, selectVal: false });
        }
    };
    onchange = (e: any) => {
        this.setState({ [e.target.name]: e.target.value.replace(/\s+/g, ' ').trim(), selectVal: false });
    };
    gettakenFiles = () => {
        this.setState({ isFileRefresh: false })
        const user: any = localStorage.getItem("user");
        const userId = user ? JSON.parse(user)["userId"] : "";
        const roleid = user ? JSON.parse(user)["role_id"] : "";
        const roletype = user ? JSON.parse(user)["roleType"] : "";
        const req = {
            user_id: userId,
            role_id: roleid,
            role_type: roletype
        }
        callApi("POST", "signature_taken_file.php", req)
            .then(res => res.data)
            .then(response => {
                const files = response.taken_files;
                if (files && files.length > 0) {
                    files.forEach((file, index) => {
                        Object.keys(file).forEach(fileKey => {
                            file[fileKey] = !file[fileKey] ? "" : typeof file[fileKey] !== 'string' ? String(file[fileKey]) : file[fileKey];
                        })
                        file.index = index + 1;
                    })
                    localStorage.setItem("takenfile_id", JSON.stringify(files[0].id));
                    this.setState({ takenfiles: files, isFileRefresh: true });
                }
            })
            .catch(err => {
                console.log(err);
            });
    };
    goToFileDashboard = (id, source) => {
        const url = `/signature-work-inprogress`;
        localStorage.setItem("url", url);
        let obj = { "file_id": id }
        localStorage.setItem("thisPopup", JSON.stringify(obj))
        localStorage.setItem("currentfileId", JSON.stringify(id));
        // this.props.history.push("/file-dashboard/" + id);
        const path = source == 'verification' ? "LegalTab" : "VettingTab";
        this.props.history.push({
            pathname: `/signature-file/${id}`,
            state: { hash: path === "LegalTab" ? "Legal" : "Vetting", takeFile: true },
            hash: path === "LegalTab" ? "#Legal" : "#Vetting",
        });
    };

    //take new file from auto assign
    gettakefile = () => {
        var randomNumber = Math.floor(Math.random() * (30 - 10 + 1)) + 10;
        console.log("randomNumber", randomNumber);
        this.setState({ takeTime: true });
        setTimeout(() => {
            console.log("randomNumber--", randomNumber);
            this.setState({ takeTime: false });
        }, randomNumber * 1000);
        this.setState({ isFileRefresh: false })
        const user: any = localStorage.getItem("user");
        const userId = user ? JSON.parse(user)["userId"] : "";
        const roleid = user ? JSON.parse(user)["role_id"] : "";
        const roletype = user ? JSON.parse(user)["roleType"] : "";
        const user_grade: any = localStorage.getItem("user_grade");
        const e_grade: any = localStorage.getItem("e_grade");
        const v_grade: any = localStorage.getItem("v_grade");
        const req = {
            user_id: userId,
            role_id: roleid,
            role_type: roletype,
            user_grade: user_grade,
            e_grade: e_grade,
            v_grade: v_grade
        }
        callApi("POST", "signature_auto_assign.php", req)
            .then(res => res.data)
            .then(response => {
                const files: any = [];
                if (response.status == 200) {
                    if (response && response.file_id) {
                        let fileid = response.file_id;
                        localStorage.setItem("takenfile_id", JSON.stringify(fileid));
                        this.goToFileDashboard(fileid, response.source);
                    }
                } else if (response && response.status == 220) {
                    toast.error(response.message, {
                        autoClose: 3000 // 3 seconds
                    });
                } else {
                    $('#no-queue-popup').modal('show');
                }
                this.setState({ takeFiles: files, isFileRefresh: true });
            })
            .catch(err => {
                console.log(err);
            })
    }

    render() {
        const columns = [
            {
                header: 'ID',
                key: 'id',
                td: (file) => <td onClick={() =>
                    this.goToFileDashboard(file.id, file.source)
                }>{file.index}</td>
            },

            {
                header: 'File ID',
                key: 'file_id',
                td: (file) => <td onClick={() =>
                    this.goToFileDashboard(file.id, file.source)
                }>{file.file_id}</td>
            },
            {
                header: 'Bank Name',
                key: 'bank_name',
                td: (file) => <td onClick={() =>
                    this.goToFileDashboard(file.id, file.source)
                }> {file.bank_name} {file.product_name ? <>({file.product_name})</> : ""}</td>
            },
            {
                header: 'Bank Branch Name',
                key: 'branch_name',
                td: (file) => <td onClick={() =>
                    this.goToFileDashboard(file.id, file.source)
                }>{file.branch_name}</td>
            },
            {
                header: 'Borrower Name',
                key: 'borrower_name',
                td: (file) => <td onClick={() =>
                    this.goToFileDashboard(file.id, file.source)
                }>{file.borrower_name}</td>
            },
            {
                header: 'Property Owner Name',
                key: 'property_ownername',
                td: (file) => <td onClick={() =>
                    this.goToFileDashboard(file.id, file.source)
                }>{file.property_ownername}</td>
            },
            {
                header: 'Law Hands Branch',
                key: 'lh_branch_name',
                td: (file) => <td onClick={() =>
                    this.goToFileDashboard(file.id, file.source)
                }>{file.lh_branch_name}</td>
            },
            {
                header: 'Created Date',
                key: 'created_dt',
                td: (file) => <td onClick={() =>
                    this.goToFileDashboard(file.id, file.source)
                }>{file.created_dt}</td>
            }
        ];
        const data = this.state.takenfiles;
        const { selectVal } = this.state;
        return (
            <section className="pcoded-main-container">
                <ToastsContainer
                    store={ToastsStore}
                    position={ToastsContainerPosition.TOP_RIGHT}
                />{" "}
                <div className="pcoded-wrapper">
                    <div className="pcoded-content">
                        <div className="pcoded-inner-content">
                            <div className="main-body">
                                <div className="page-wrapper">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h5 className="file-status-header">Signature Work InProgress Files</h5>
                                                    <div className="file-search-button">
                                                        {this.state.autoAssign && this.state.autoAssign.find(
                                                            (data: any) => data.module_name === "Auto Assign" && data.status == false) ?
                                                            <>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary"
                                                                    data-toggle="modal"
                                                                    data-target="#file-search-modal"
                                                                >
                                                                    File Search
                                                                </button>
                                                            </> : ""}

                                                    </div>
                                                </div>
                                                {this.state.autoAssign && this.state.autoAssign.find(
                                                    (data: any) => data.module_name === "Auto Assign" && data.status) &&
                                                    <>
                                                        <div className="card-body" style={{ marginTop: "2%" }}>
                                                            {data.length == 0 ?
                                                                <>
                                                                    <div className="" style={{ display: "flex", justifyContent: "center", padding: "18%" }}>
                                                                        <div style={{ textAlign: "center" }}>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-primary"
                                                                                onClick={this.gettakefile}
                                                                                disabled={this.state.takeTime}
                                                                            >
                                                                                Take file
                                                                            </button><br />
                                                                            <b style={{ fontSize: "17px" }}>{this.state.filesCount ? this.state.filesCount : "0"} Files Waiting in Queue</b>
                                                                        </div>
                                                                    </div>
                                                                </> :
                                                                <>
                                                                    {data && this.state.isFileRefresh &&
                                                                        <>
                                                                            {data.length > 0 &&
                                                                                <ReactFlexyTable data={data} columns={columns} sortable globalSearch />
                                                                            }
                                                                        </>
                                                                    }</>
                                                            }
                                                        </div>
                                                    </>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="modal"
                    id="no-queue-popup"
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-lg" role="document" style={{
                        display: "grid !importent", placeItems: "center !importent", margin: "10% auto !importent", justifyContent: "center !importent"
                    }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <h5 className="modal-title" style={{ textAlign: "center" }}>In Queue there is no Files, please wait for some times.</h5>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* THIS FOR OUT REASON MODAL */}
                <div className="modal fade hide in" id="out_reason" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog ">
                        <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
                            <div className="modal-body" style={{ padding: '30px 23px 29px 24px' }}>
                                <h3 style={{ margin: 'auto', fontSize: '17px' }}>Please Select The Reason For To Close The File.No:{localStorage.getItem("currentfileId")}</h3>
                            </div>
                            <div className="form-group" style={{ width: '74%', margin: 'auto' }}>
                                <select
                                    className="custom-select"
                                    name="outreason"
                                    value={this.state.outreason}
                                    onChange={(e) => this.onchangeReason(e)}
                                    required
                                    id="select1"
                                    style={{ marginTop: '8px' }}
                                >
                                    <option value="select">Select Your Reason</option>
                                    <option value="Query Raised">Query Raised</option>
                                    <option value=" Re-Query Raised"> Re-Query Raised</option>
                                    <option value="Hold ">Hold </option>
                                    <option value="Completed">Completed</option>
                                    <option value="Other">Others</option>

                                </select>
                                {selectVal ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please Select Your Reason </p> : null}
                            </div>
                            <div className="modal-footer" style={{ marginTop: '27px' }}>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={this.state.isLoading}
                                    onClick={this.outimeGet}
                                    style={{ width: '76px', fontSize: '17px' }}
                                > {this.state.isLoading ? (
                                    <i className="fa fa-spinner fa-spin"></i>
                                ) : "OK"}</button>
                                <button
                                    type="button"
                                    className="btn btn-outline"
                                    onClick={this.BacktoFile}
                                    style={{ width: '107px', fontSize: '14px', border: '1px solid black', height: '43px' }}
                                > Back To File</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* OTHER REASON MODAL */}
                <div className="modal hide fade in" id="another-reason" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog ">
                        <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
                            <h5 style={{ marginTop: '31px', textAlign: 'center' }}>Please Type a Reason To Close The File.No: {localStorage.getItem("currentfileId")} </h5>
                            <div className="modal-body" style={{ padding: '30px 23px 29px 24px' }}>
                                <div className="form-group" style={{ width: '98%', margin: 'auto' }}>
                                    <textarea
                                        className="form-control"
                                        placeholder="Type Your Reason"
                                        name="outreason" onChange={this.onchange} />
                                    {selectVal ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please Select Your Reason </p> : null}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => this.outimeGet()}
                                    style={{ width: '76px', fontSize: '17px' }}

                                >{this.state.isLoading ? (
                                    <i className="fa fa-spinner fa-spin"></i>
                                ) : "OK"}</button>
                                <button
                                    type="button"
                                    className="btn btn-outline"
                                    onClick={() => this.previousPop()}
                                    style={{ width: '76px', fontSize: '17px', border: '1px solid black' }}
                                > Back</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        );
    }
}
export default SignatureInprogressFile;
